<template>
	<div class="customerOverview" :style="{'height': clientHeight+'px' }">
		<div class="leftBox" style="overflow: auto;">
			<div class="customerLeft">
				<el-input prefix-icon="el-icon-search" v-model="username" size="small" @input="searchInput()" placeholder="请输入客户名称" class="inputClass"></el-input>
				<div style="box-shadow: 0 0 6px #999999;">
					<el-collapse @change="handleChange" accordion v-model="activenNames">
						<div @mouseleave.stop="mouseLeave(index,item.id)" @mouseover.stop="mouseOver(index,item.id)" v-for="(item,index) in customerLsit">
							<el-collapse-item :name="index">
								<template slot="title">
									<i :class="item.classNo"></i>{{item.name}}
								</template>
								<div class="openBox">
									<div class="energyClass" @click="engreySetClick(item.id,item)">能耗配置</div>
									<div class="seeClass" @click="detailClick2(item.id,item.name,b_id)">查看</div>
								</div>
							</el-collapse-item>
						</div>
					</el-collapse>
				</div>
			</div>
		</div>
		<div class="mapRight">
			<div id="map" style="width:100%;height:100%;position: relative;"></div>
			<div class="noBox" @click="centerClick">
				<i class="iconfont icon-quanping-fangda-07"></i>
			</div>
			<div class="levBox">
				<div class="mapLev">地图级别：{{mapLev}}</div>
				<button class="defaultButton" @click="defaultLevClick">点击保存为默认级别</button>
			</div>
		</div>
		<!--弹窗1-->
		<el-dialog title="" :visible.sync="dialogFormVisible" :width="dialogWidth1" :close-on-click-modal="false">
			<el-table :data="event_deviceList" style="width: 100%" v-loading="loading1" border>
				<el-table-column prop="data_time" label="发生时间" min-width="2%">
				</el-table-column>
				<el-table-column prop="_path" label="发生位置" min-width="3%">
				</el-table-column>
				<el-table-column prop="link_man" label="报警数汇总" min-width="3%">
					<template slot-scope="scope">
						高风险{{scope.row.h_num}}、中风险{{scope.row.m_num}}、低风险{{scope.row.l_num}}
					</template>
				</el-table-column>
				<el-table-column prop="link_tel" label="发送状态" min-width="2%">
					<template slot-scope="scope">
						{{scope.row.status|statusFilter}}
					</template>
				</el-table-column>
				<el-table-column prop="gateway_addr" label="上报通讯地址" min-width="2%">
				</el-table-column>
				<el-table-column prop="device_addr" label="通讯地址" min-width="2%">
				</el-table-column>
				<el-table-column prop="address" label="操作" min-width="2%">
					<template slot-scope="scope">
						<a class="editClass" @click="detailClick(scope.row.device_id,scope.row.id)">查看详细</a>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<!--弹窗2-->
		<div class="specliDialog">
			<el-dialog title="" :visible.sync="dialogFormVisible2" :width="dialogWidth2" :close-on-click-modal="false">
				<div class="iconBox">
					<div class="backIcon">
						<i class="el-icon-arrow-left iconClass" @click="backIconClick('2')"></i>
					</div>
					<div class="closeIcon">
						<i class="el-icon-close iconClass" @click="closeIconClick('2')"></i>
					</div>
				</div>
				<div class="detailBox">
					<div class="modelClass">设备型号：{{subprojectObj.model}}</div>
					<div class="codeClass">设备编号：{{subprojectObj.code}}</div>
					<div class="seturlClass">发生位置：{{urlValue}}/{{subprojectObj.name}}</div>
				</div>
				<el-table :data="detailList" style="width: 100%" v-loading="loading2" border>
					<el-table-column prop="" label="级别" min-width="1%">
						<template slot-scope="scope">
							<div class="signBox1" v-if="scope.row.event_lev==3">{{scope.row.event_lev|event_levFilter}}</div>
							<div class="signBox2" v-if="scope.row.event_lev==2">{{scope.row.event_lev|event_levFilter}}</div>
							<div class="signBox3" v-if="scope.row.event_lev==1">{{scope.row.event_lev|event_levFilter}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="data_time" label="发生时间" min-width="3%">
					</el-table-column>
					<el-table-column prop="event_end" label="结束时间" min-width="3%">
					</el-table-column>
					<el-table-column prop="event_name" label="类别" min-width="2%">
					</el-table-column>
					<el-table-column prop="address" label="操作" min-width="1%">
						<template slot-scope="scope">
							<a class="editClass" @click="currentClick(scope.row.id,scope.row.data_item_id)">查看当时值</a>
						</template>
					</el-table-column>
				</el-table>
			</el-dialog>
		</div>
		<!--弹窗3-->
		<div class="specliDialog">
			<el-dialog title="" :visible.sync="dialogFormVisible3" :width="dialogWidth3" :close-on-click-modal="false">
				<div class="iconBox">
					<div class="backIcon">
						<i class="el-icon-arrow-left iconClass" @click="backIconClick('3')"></i>
					</div>
					<div class="closeIcon">
						<i class="el-icon-close iconClass" @click="closeIconClick('3')"></i>
					</div>
				</div>
				<div class="titleBox">
					报警时数据
				</div>
				<div class="contentDialog">
					<div class="contentValue" v-for="item in currentList">{{item.title}}：{{item.val}}{{item.unit_name}}</div>
				</div>
			</el-dialog>
		</div>
		<!--弹窗4-->
		<el-dialog title="" :visible.sync="dialogFormVisible4" :width="dialogWidth2" :close-on-click-modal="false">
			<div class="checkAllBox2">
				<el-checkbox v-model="checkedAll" @change="checkedAllChange()">全选</el-checkbox>
			</div>
			<div class="ergencyLi" v-for="item in deviceList" v-if="deviceList.length>0">
				<el-checkbox v-model="item.selected" @change="checkboxChange(item.selected,item.id,item.energy_id)">{{item.addr}}</el-checkbox>
			</div>
			<div v-if="deviceList.length==0">
				无数据！
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="save()" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible4=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	var mapLev = 6;

	function ZoomControl() {
		// 设置默认停靠位置和偏移量  
		this.defaultAnchor = BMAP_ANCHOR_BOTTOM_RIGHT;
		this.defaultOffset = new BMap.Size(156, 8);
	}
	// 通过JavaScript的prototype属性继承于BMap.Control   
	ZoomControl.prototype = new BMap.Control();
	// 自定义控件必须实现initialize方法，并且将控件的DOM元素返回   
	// 在本方法中创建个div元素作为控件的容器，并将其添加到地图容器中
	ZoomControl.prototype.initialize = function(map) {
		//创建一个DIV
		var mydiv = document.createElement("div");
		mydiv.style.color = "#666";
		//减号按钮
		var img_minusdiv = document.createElement("div");
		img_minusdiv.style.width = "20px";
		img_minusdiv.style.height = "20px";
		img_minusdiv.style.lineHeight = "20px";
		img_minusdiv.style.textAlign = "center";
		img_minusdiv.style.border = "1px solid #999";
		img_minusdiv.style.boxShadow = "0 0 6px #000";
		img_minusdiv.style.display = "inline-block";
		img_minusdiv.style.marginRight = "10px";
		img_minusdiv.style.backgroundColor = "#fff";
		img_minusdiv.style.cursor = "pointer";
		img_minusdiv.style.boxShadow = " 0 0 6px #999999";
		var img_minus = document.createElement("i");
		img_minus.setAttribute("class", "iconfont icon-jianhao");
		img_minus.onclick = function() {
			map.zoomTo(map.getZoom() - 1);
			mapLev = mapLev - 1
			getMapLev();
		}
		img_minusdiv.appendChild(img_minus);
		mydiv.appendChild(img_minusdiv);
		//加号按钮
		var img_plusdiv = document.createElement("div");
		img_plusdiv.style.width = "20px";
		img_plusdiv.style.height = "20px";
		img_plusdiv.style.lineHeight = "20px";
		img_plusdiv.style.textAlign = "center";
		img_plusdiv.style.border = "1px solid #999";
		img_plusdiv.style.boxShadow = "0 0 6px #000";
		img_plusdiv.style.display = "inline-block";
		img_plusdiv.style.marginRight = "10px";
		img_plusdiv.style.backgroundColor = "#fff";
		img_plusdiv.style.cursor = "pointer";
		img_plusdiv.style.boxShadow = " 0 0 6px #999999";
		var img_plus = document.createElement("i");
		img_plus.setAttribute("class", "iconfont icon-jiahao1");
		img_plus.onclick = function() {
			map.zoomTo(map.getZoom() + 1);
			mapLev = mapLev + 1
			getMapLev();
		}
		img_plusdiv.appendChild(img_plus);
		mydiv.appendChild(img_plusdiv);

		//添加DOM元素到地图中
		map.getContainer().appendChild(mydiv);
		//将DOM元素返回；
		return mydiv;
	}
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			window.getMapLev = this.getMapLev; //定义为全局函数
			if(window.sessionStorage.getItem('mapLev')) {
				this.mapLev = Number(window.sessionStorage.getItem('mapLev'))
				mapLev = Number(window.sessionStorage.getItem('mapLev'))
			} else {
				this.mapLev = mapLev
			}
			var offset = $(".customerOverview").offset()
			this.clientHeight = document.body.clientHeight - offset['top']
			this.b_id = window.sessionStorage.getItem('b_id')
			this.getCustomerList(); //客户列表
			this.getEventProjectFun('all'); //获取B端下报警提示
			this.mapAllFun(); //地图初始化
			window.addEventListener('resize', () => {
				var offset = $(".customerOverview").offset()
				this.clientHeight = document.body.clientHeight - offset['top']
			})
		},
		filters: {
			event_levFilter: function(val) {
				if(val == "1") {
					return "低风险";
				}
				if(val == "2") {
					return "中风险";
				}
				if(val == "3") {
					return "高风险";
				}
			},
			event_statusFilter: function(val) {
				if(val == "0") {
					return "待发送";
				}
				if(val == "1") {
					return "发送成功";
				}
				if(val == "2") {
					return "发送失败";
				}
				if(val == "3") {
					return "已发送，已收到";
				}
			},
			statusFilter: function(val) {
				if(val == "0") {
					return "待发送";
				}
				if(val == "1") {
					return "发送成功";
				}
				if(val == "2") {
					return "发送失败";
				}
				if(val == "3") {
					return "已收到";
				}
			},
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth1 = "100%"
				this.dialogWidth2 = "100%"
				this.dialogWidth3 = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth1 = "90%"
				this.dialogWidth2 = "58%"
				this.dialogWidth3 = "70%"
			} else {
				this.dialogWidth = "80%"
				this.dialogWidth2 = "70%"
				this.dialogWidth3 = "38%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				b_id: '', //b_id
				/*左*/
				customerLsit: [], //客户列表
				customerLsitCopy: [], //客户列表copy
				c_ID: '', //c_ID
				deviceList: [], //设备列表（能耗配置列表）
				clientHeight: '', //滚动高度
				/*所有项目列表*/
				projectList: [], //项目列表
				/*列表获取B端下报警提示*/
				warnProjectList: [], //B端下报警提示列表
				currentWarnObj: {}, //当前报警对象
				deviceTotal: [], //某项目设备统计
				event_deviceList: [], //某设备历史报警列表
				urlValue: '', //设备路径
				subprojectObj: {}, //项目信息
				detailList: [], //报警信息详细列表
				currentList: [], //查看当时值列表
				loading1: false,
				loading2: false,
				username: '',
				warningShow: false, //
				dialogFormVisible: false,
				dialogFormVisible2: false,
				dialogFormVisible3: false,
				dialogFormVisible4: false,
				dialogWidth1: '80%', //dialog的宽度
				dialogWidth2: '70%', //dialog的宽度
				dialogWidth3: '38%', //dialog的宽度
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				checkedAll: false, //全选
				activenNames: [],
				mapLev: 0, //地图等级
				localLongitude: 120.19, //本地经度
				localLatitude: 30.26, //本地纬度
				map: null,
			}
		},
		methods: {
			/*
			 * 左
			 * */
			//获取客户列表
			getCustomerList() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
					b_id: this.b_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.customerLsit = res.data
						this.customerLsitCopy = res.data
						this.customerLsit.forEach(item => {
							item.classNo = 'header-icon iconfont icon-yuanquan iconClass2'
							item.default = false
						})
						this.customerLsitCopy.forEach(item => {
							item.classNo = 'header-icon iconfont icon-yuanquan iconClass2'
							item.default = false
						})
					} else {
						this.customerLsit = []
						this.customerLsitCopy = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			/*
			 * 折叠客户信息
			 * */
			handleChange(index) {
				if(String(index).length > 0) {
					index = Number(index)
					this.customerLsit.forEach((item, i) => {
						if(index == i) {
							item.default = true
						}
					})
				} else {
					this.customerLsit.forEach((item, i) => {
						item.default = false
					})
				}
			},
			mouseOver(index, c_id) {
				this.customerLsit.forEach((item, i) => {
					if(index == i && !item.default) {
						this.customerLsit.forEach((item, i) => {
							item.classNo = 'header-icon iconfont icon-yuanquan iconClass2'
						})
						item.classNo = 'header-icon iconfont icon-yk_yuanquan_fill iconClass2'
						this.activenNames = []
					}
				})
				this.danFun(c_id);
			},
			danFun(c_id) {
				var params = {
					pageSize: -1,
					pageIndex: 1,
					c_id: c_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/project/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						//console.log('aaa')
						/*清除绘点*/
						var allOverlay = this.map.getOverlays();
						for(var i = 0; i < allOverlay.length; i++) {
							this.map.removeOverlay(allOverlay[i]);
						}
						this.projectList = res.data
						this.projectList.forEach(item => {
							item.warnSign = false
							this.warnProjectList.forEach(item_w => {
								if(item_w.id == item.id) {
									item.warnSign = true
								}
							})
						})
						this.mapHDFun();
					}
				}).catch(err => {
					console.log(err)
				})
			},
			mouseLeave(index, c_id) {
				this.customerLsit.forEach((item, i) => {
					if(index == i && !item.default) {
						this.projectList = JSON.parse(window.localStorage.projectListArr);
						//						if(!this.username) {
						//							
						//						}
						this.mapHDFun();
						this.customerLsit.forEach((item, i) => {
							item.default = false
						})
						item.classNo = 'header-icon iconfont icon-yuanquan iconClass2'
						this.$forceUpdate() //局部更新
					}
				})
			},
			//能耗配置的点击
			engreySetClick(id, val) {
				this.c_ID = id
				this.dialogFormVisible4 = true
				//能耗配置列表(设备)
				var params = {
					c_id: id,
				}
				//console.log(params)
				let config = headers.headers('getDeviceList')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/energy/getDeviceList', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.selected == 0) {
								item.selected = false
							} else {
								item.selected = true
							}
						})
						this.deviceList = res.data
						var checkedArr = []
						this.deviceList.forEach(item => {
							if(item.selected == true) {
								checkedArr.push(item)
							}
						})
						if(checkedArr.length == this.deviceList.length) {
							this.checkedAll = true
						} else {
							this.checkedAll = false
						}
					} else {
						this.deviceList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//复选框改变（能耗配置的保存）（单选的改变）
			checkboxChange(val, device_id, id) {
				var checkedArr = []
				this.deviceList.forEach(item => {
					if(item.selected == true) {
						checkedArr.push(item)
					}
				})
				if(checkedArr.length == this.deviceList.length) {
					this.checkedAll = true
				} else {
					this.checkedAll = false
				}
				var timestamp = Date.parse(new Date());
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(val == true) { //添加
					axios.post(this.http + '/zkep2/energy/save',
						qs.stringify({
							src: 3,
							c_id: this.c_ID,
							device_id: device_id,
							b_manager_id: this.b_id,
							create_time: timestamp,
							status: 1,
							version: 0
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				} else { //删除
					axios.post(this.http + '/zkep2/energy/save',
						qs.stringify({
							id: id,
							status: 0,
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//全选、全不选
			checkedAllChange() {
				var timestamp = Date.parse(new Date());
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.checkedAll) {
					this.deviceList.forEach(item => {
						item.selected = true
					})
					for(var i = 0; i < this.deviceList.length; i++) {
						axios.post(this.http + '/zkep2/energy/save',
							qs.stringify({
								src: 3,
								c_id: this.c_ID,
								device_id: this.deviceList[i].id,
								b_manager_id: this.b_id,
								create_time: timestamp,
								status: 1,
								version: 0
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {} else {
								this.$message('操作失败！');
							}
						}).catch(err => {
							console.log(err)
						})
					}
				} else {
					this.deviceList.forEach(item => {
						item.selected = false
					})
					for(var i = 0; i < this.deviceList.length; i++) {
						axios.post(this.http + '/zkep2/energy/save',
							qs.stringify({
								id: this.deviceList[i].energy_id,
								status: 0,
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {} else {
								this.$message('操作失败！');
							}
						}).catch(err => {
							console.log(err)
						})
					}
				}
			},
			//立即创建（能耗配置）
			save() {
				this.dialogFormVisible4 = false
			},
			//查看
			detailClick2(id, name, b_id) {
				this.$router.push({
					path: '/customer/customerC',
					name: 'CustomerC',
					query: {
						c_id: id,
						name: name,
						b_id: b_id
					}
				})
			},
			/*
			 * 绘点
			 * */
			//获取B端下报警提示
			getEventProjectFun() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getEventProject')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/screenShow/getEventProject', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.warnProjectList = res.data
					} else {
						this.warnProjectList = []
					}
					this.getByBList(); //所有项目列表
				}).catch(err => {
					console.log(err)
				})
			},
			//所有项目列表(所有)
			async getByBList() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				const res = await axios.get(this.http + '/zkep2/project/getByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.projectList = res.data
						/*报警标识处理*/
						this.projectList.forEach(item => {
							item.warnSign = false
							this.warnProjectList.forEach(item_w => {
								if(item_w.id == item.id) {
									item.warnSign = true
								}
							})
						})
						window.localStorage.projectListArr = JSON.stringify(this.projectList);
						this.mapHDFun();
					} else {
						this.projectList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//鼠标经过的项目列表
			getoverList() {

			},
			/*地图初始化*/
			mapAllFun() {
				/*初始化地图*/
				this.map = new BMap.Map("map"); // 创建Map实例
				this.map.centerAndZoom(new BMap.Point(this.localLongitude, this.localLatitude), this.mapLev); // 初始化地图,设置中心点坐标和地图级别
				this.mapHDFun();
				//添加地图类型控件
				this.map.addControl(new BMap.MapTypeControl({
					mapTypes: [
						BMAP_NORMAL_MAP, //地图模式
					]
				}));
				this.map.setCurrentCity("杭州");
				//styleJson地图样式
				var styleJson = [{
						"featureType": "land",
						"elementType": "geometry",
						"stylers": {
							"visibility": "on",
							"color": "#FEFFFFFF"
						}
					}, {
						"featureType": "water",
						"elementType": "geometry",
						"stylers": {
							"visibility": "on",
							"color": "#69AEE7ff"
						}
					},
					//文字
					{
						"featureType": "all",
						"elementType": "labels.text.fill",
						"stylers": {
							"color": "#2da0c6",
							"visibility": "off"
						}
					},
					//网格
					{
						'featureType': 'road',
						"elementType": 'all',
						'stylers': {
							'visibility': 'off'
						}
					}, {
						"featureType": "city",
						"elementType": "labels.icon",
						"stylers": {
							"visibility": "off"
						}
					},

				]
				/*this.map.setMapStyleV2({
					styleId: '396bf7ded5259a4198730fc9ec45d522'
				})*/
				this.map.setMapStyleV2({
					styleJson: styleJson
				})
				var myZoomCtrl = new ZoomControl(); // 创建控件实例 （自定义控件必须有）   
				this.map.addControl(myZoomCtrl); // 添加到地图当中    
			},
			/*绘点fun*/
			mapHDFun() {
				this.projectList.forEach(item => {
					item.point = item.longitude + '|' + item.latitude
				})
				var point = []; //定义数组标注经纬信息
				var marker = []; //定义数组点对象信息
				/*渲染多个地图绘点*/
				if(document.createElement('canvas').getContext) { // 判断当前浏览器是否支持绘制海量点
					for(var i = 0; i < this.projectList.length; i++) { //遍历
						var infoA = this.projectList[i].point.split("|")[0]; //分割|
						var infoB = this.projectList[i].point.split("|")[1];
						var icon;
						if(this.projectList[i].warnSign) {
							icon = new BMap.Icon(require('../../assets/red2.png'), new BMap.Size(50, 50));
						} else {
							icon = new BMap.Icon(require('../../assets/greenSign.png'), new BMap.Size(50, 50));
						}
						point[i] = new window.BMap.Point(infoA, infoB);
						marker[i] = new window.BMap.Marker(point[i], {
							icon: icon
						});
						this.map.addOverlay(marker[i]);
						var _this = this
						marker[i].addEventListener('onmouseover', function(e) {
							var p = e.target;
							_this.projectList.forEach(item => {
								if(item.longitude == p.getPosition().lng && item.latitude == p.getPosition().lat) {
									_this.currentWarnObj = item
									/*网关、设备的在线、离线值*/
									var params = {
										project_id: _this.currentWarnObj.id
									}
									//console.log(params)
									let config = headers.headers('countProjectDevice')
									var pass_token = config.pass_token
									var timestamp = config.timestamp
									axios.get(_this.http + '/zkep2/screenShow/countProjectDevice', {
										params,
										headers: {
											'pass-token': pass_token,
											'time': timestamp
										}
									}).then(res => {
										//console.log(res)
										if(res.data) {
											_this.deviceTotal = res.data
											/*高、中、低风险的值*/
											let config2 = headers.headers('getProjectUnendEvent')
											var pass_token = config2.pass_token
											var timestamp = config2.timestamp
											axios.get(_this.http + '/zkep2/event/getProjectUnendEvent', {
												params,
												headers: {
													'pass-token': pass_token,
													'time': timestamp
												}
											}).then(res => {
												//console.log(res)
												var hignNum = 0;
												var middleNum = 0;
												var lowNum = 0;
												res.data.forEach(item => {
													if(item.event_lev == '3') {
														hignNum++;
													} else if(item.event_lev == '2') {
														middleNum++;
													} else if(item.event_lev == '1') {
														lowNum++;
													}
												})
												var opts = {
													title: "<div class='projectClass' style='font-size:12px;width:100%;' id='ceshi'><i class='iconfont icon-duidiedefangkuai-copy duidieClass'></i> " + _this.currentWarnObj.name + "</div>",
													offset: new BMap.Size(-11, -20),
												};
												var infoWindow = new BMap.InfoWindow('<div id="ceshi2"><div class="gatewayBox"><div class="numberClass"><div>网关总数</div><div class="numberD">' + (_this.deviceTotal.gateway_on + _this.deviceTotal.gateway_off) + '</div></div><div class="numberClass"><div>在线网关</div><div class="numberD">' + _this.deviceTotal.gateway_on + '</div></div><div class="numberClass"><div>离线网关</div><div class="numberD">' + _this.deviceTotal.gateway_off + '</div></div></div><div class="gatewayBox"><div class="numberClass"><div>设备总数</div><div class="numberD">' + (_this.deviceTotal.device_on + _this.deviceTotal.device_off) + '</div></div><div class="numberClass"><div>在线设备</div><div class="numberD">' + _this.deviceTotal.device_on + '</div></div><div class="numberClass"><div>离线设备</div><div class="numberD">' + _this.deviceTotal.device_off + '</div></div></div><div class="gatewayBox"><div class="numberClass"><div class="signBox1">高风险</div><div class="numberD">' + hignNum + '</div></div><div class="numberClass"><div class="signBox2">中风险</div><div class="numberD">' + middleNum + '</div></div><div class="numberClass"><div class="signBox3">低风险</div><div class="numberD">' + lowNum + '</div></div></div><button class="historyButton">历史报警</button></div>', opts); // 创建信息
												this.openInfoWindow(infoWindow);
												var ceshi = document.getElementById('ceshi')
												//console.log(ceshi)
												ceshi.addEventListener('click', function(e) {
													_this.getEvent_deviceList();
													//console.log('aaaa')
													_this.map.closeInfoWindow()
												});
												var ceshi2 = document.getElementById('ceshi2')
												ceshi2.addEventListener('click', function(e) {
													_this.getEvent_deviceList();
													_this.map.closeInfoWindow()
													//console.log('aaaa')
												});

											}).catch(err => {
												console.log(err)
											})
										} else {
											this.deviceTotal = res.data = []
										}
									}).catch(err => {
										console.log(err)
									})
								}
							})
						});
						//								marker[i].addEventListener('onmouseout', function(e) {
						//									map.closeInfoWindow()
						//								});
					}
				} else {
					alert('请在chrome、safari、IE8+以上浏览器查看本示例');
				}
			},
			/*
			 * 绘点历史报警
			 * */
			//某设备历史报警列表
			getEvent_deviceList() {
				this.dialogFormVisible = true
				this.loading1 = true;
				var params = {
					pageSize: -1,
					pageIndex: 1,
					project_id: this.currentWarnObj.id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event_device/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading1 = false;
					//console.log(res)
					if(res.data.length > 0) {
						this.event_deviceList = res.data
					} else {
						this.event_deviceList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//查看详细
			detailClick(device_id, event_device_id) {
				this.getDeviceObj(device_id);
				this.getFaultalarmList(event_device_id);
				this.dialogFormVisible2 = true
			},
			//设备信息
			getDeviceObj(device_id) {
				//console.log(params)
				var params = {}
				var config1 = headers.headers(device_id)
				var pass_token = config1.pass_token
				var timestamp = config1.timestamp
				axios.get(this.http + '/zkep2/device/' + device_id, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					if(res.data.id) {
						var params = {
							id: res.data.subproject_id
						}
						let config = headers.headers('getPath')
						var pass_token = config.pass_token
						var timestamp = config.timestamp
						axios.get(this.http + '/zkep2/subproject/getPath', {
							params,
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							if(res.data) {
								this.urlValue = res.data
							} else {
								this.urlValue = ''
							}
						}).catch(err => {
							console.log(err)
						})
						let config2 = headers.headers(res.data.subproject_id)
						var pass_token = config2.pass_token
						var timestamp = config2.timestamp
						axios.get(this.http + '/zkep2/subproject/' + res.data.subproject_id, {
							params,
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							if(res.data.id) {
								this.subprojectObj = res.data
							} else {
								this.subprojectObj = {}
							}
						}).catch(err => {
							console.log(err)
						})
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//报警信息列表
			getFaultalarmList(event_device_id) {
				this.loading2 = true;
				var params = {
					pageSize: -1,
					pageIndex: 1,
					event_device_id: event_device_id
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading2 = false;
					//console.log(res)
					if(res.data.length > 0) {
						this.detailList = res.data
					} else {
						this.detailList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//查看当时值
			currentClick(event_id, data_item_id) {
				this.dialogFormVisible3 = true
				var params = {
					event_id: event_id,
				}
				//console.log(params)
				let config = headers.headers('getByEvent')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event_detail/getByEvent', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.currentList = res.data
					} else {
						var params1 = {}
						var config1 = headers.headers(data_item_id)
						var pass_token = config1.pass_token
						var timestamp = config1.timestamp
						axios.get(this.http + '/zkep2/data_item/' + data_item_id, {
							params1,
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
							//console.log(res)
							this.getRwo(res.data.data_id)
						}).catch(err => {
							console.log(err)
						})
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//备份列表
			getRwo(data_id) {
				var params = {
					data_id: data_id
				}
				let config = headers.headers('getByDataWithTitle')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/data_item/getByDataWithTitle', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.currentList = res.data
					} else {
						this.currentList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//返回
			backIconClick(val) {
				if(val == '2') {
					this.dialogFormVisible2 = false
				} else if(val == '3') {
					this.dialogFormVisible3 = false
				}
			},
			//关闭
			closeIconClick(val) {
				if(val == '2') {
					this.dialogFormVisible = false
					this.dialogFormVisible2 = false
				} else if(val == '3') {
					this.dialogFormVisible = false
					this.dialogFormVisible2 = false
					this.dialogFormVisible3 = false
				}
			},
			/*
			 * 地图
			 * */
			//地图级别
			getMapLev() {
				this.mapLev = mapLev;
			},
			//中心点
			centerClick() {
				if(window.sessionStorage.getItem('mapLev')) {
					this.mapLev = Number(window.sessionStorage.getItem('mapLev'))
				} else {
					this.mapLev = 6
				}
				this.mapAllFun();
			},
			//默认地图等级
			defaultLevClick() {
				window.sessionStorage.setItem('mapLev', this.mapLev)
			},
			//搜索匹配
			searchInput() {
				let newarr = [];
				this.customerLsitCopy.forEach((item, index) => {
					if(item.name.toLowerCase().indexOf(this.username) > -1) { // 判断是否含有匹配的值;
						newarr.push(item);
					}
				})
				this.customerLsit = newarr
				this.customerLsit.forEach(item => {
					item.classNo = 'header-icon iconfont icon-yuanquan iconClass2'
					item.default = false
				})
				this.searchFun();
			},
			searchFun() {
				var customerLsitArr = []
				for(var i = 0; i < this.customerLsit.length; i++) {
					var params = {
						pageSize: -1,
						pageIndex: 1,
						c_id: this.customerLsit[i].id,
					}
					//console.log(params)
					let config = headers.headers('getListByLimit')
					var pass_token = config.pass_token
					var timestamp = config.timestamp
					axios.get(this.http + '/zkep2/project/getListByLimit', {
						params,
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.length > 0) {
							res.data.forEach(item => {
								item.warnSign = false
								this.warnProjectList.forEach(item_w => {
									if(item_w.id == item.id) {
										item.warnSign = true
									}
								})
								customerLsitArr.push(item)
							})
							/*清除绘点*/
							var allOverlay = this.map.getOverlays();
							for(var i = 0; i < allOverlay.length; i++) {
								this.map.removeOverlay(allOverlay[i]);
							}
							this.projectList = customerLsitArr
							this.mapHDFun();
						}
					}).catch(err => {
						console.log(err)
					})
				}

			},
		}
	}
</script>

<style>
	.customerOverview {
		display: flex;
		height: 100%;
		background-color: #fff!important;
	}
	
	.customerOverview .customerLeft {
		min-width: 300px;
		flex: 2;
		margin: 6px 10px;
	}
	
	.customerOverview .inputClass {
		box-shadow: 0 0 6px #999999;
		margin-bottom: 6px;
	}
	
	.customerOverview .el-input__inner:focus {
		border: 1px solid #ccc;
		/*输入框获取焦点时给边框加颜色*/
	}
	
	.customerOverview .el-input__inner {
		border-radius: 0!important;
	}
	
	.customerOverview .el-input__icon {
		color: #666;
	}
	
	.customerOverview input::-webkit-input-placeholder {
		color: #666!important;
	}
	
	.customerOverview .el-collapse-item__header {
		color: #006CEC;
		height: 36px;
		line-height: 36px;
		box-shadow: 0 0 6px #999999;
	}
	
	.customerOverview .openBox {
		box-shadow: 0 0 6px #000!important;
	}
	
	.customerOverview .energyClass {
		cursor: pointer;
		padding-left: 36px;
	}
	
	.customerOverview .seeClass {
		cursor: pointer;
		padding-left: 36px;
		padding-bottom: 6px;
	}
	
	.customerOverview .el-collapse-item__arrow {
		color: #fff;
	}
	
	.customerOverview .el-collapse-item__content {
		padding-bottom: 4px;
		color: #006CEC;
		box-shadow: 0 0 6px #999999;
	}
	
	.customerOverview .iconClass2 {
		font-size: 14px;
		margin: 0 10px;
	}
	/*去掉百度地图的图标*/
	
	.customerOverview .BMap_cpyCtrl {
		display: none;
	}
	
	.customerOverview .anchorBL {
		display: none;
	}
	/*地图按钮*/
	
	.customerOverview .anchorTR {
		display: none;
	}
	
	.customerOverview .mapRight {
		border-left: 1px solid #DCDCDC;
		position: relative;
		flex: 8;
	}
	
	.customerOverview .noBox {
		display: inline-block;
		z-index: 1;
		position: absolute;
		bottom: 8px;
		right: 134px;
		padding: 0;
		width: 20px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		border: 1px solid #ccc;
		background-color: #fff;
		box-shadow: 0 0 6px #999999;
		cursor: pointer;
	}
	/*等级*/
	
	.customerOverview .levBox {
		position: absolute;
		bottom: 8px;
		right: 8px;
		text-align: right;
	}
	
	.customerOverview .mapLev {
		font-size: 12px;
		font-weight: 600;
		margin-bottom: 3px;
	}
	
	.customerOverview .defaultButton {
		background-color: #fff;
		border: none;
		color: #0063FF;
		border-radius: 4px;
		font-size: 10px;
		padding: 2px 4px;
		outline: none;
	}
	
	.customerOverview .baseBox {
		position: absolute;
		top: 156px;
		right: 650px;
		background-color: #FAFAFA;
		box-shadow: 0 0 6px #999999;
		width: 190px;
		font-size: 12px;
		z-index: 2;
	}
	
	.customerOverview .projectClass {
		height: 36px;
		line-height: 36px;
		color: #006CEC;
	}
	
	.customerOverview .duidieClass {
		color: #1796CD;
		margin: 0 6px 0 8px;
	}
	
	.customerOverview .gatewayBox {
		margin-bottom: 22px;
		font-size: 12px!important;
	}
	
	.customerOverview .numberClass {
		display: inline-block;
		width: 30%;
		margin-left: 2%;
		text-align: center;
		vertical-align: top;
	}
	
	.customerOverview .numberD {
		margin-top: 4px;
	}
	
	.customerOverview .signBox1 {
		display: inline-block;
		background-color: #B7000D;
		width: 40px;
		color: #fff;
	}
	
	.customerOverview .signBox2 {
		display: inline-block;
		background-color: #DF894E;
		width: 40px;
		color: #000;
	}
	
	.customerOverview .signBox3 {
		display: inline-block;
		background-color: #FCB501;
		width: 40px;
		color: #fff;
	}
	
	.customerOverview .historyButton {
		width: 100%;
		height: 30px;
		color: #fff;
		background-color: #164B8F;
		border: none;
		font-size: 12px;
		padding: 6px 0;
		outline: none;
	}
	/*表格*/
	
	.customerOverview .el-table th {
		color: #000;
	}
	
	.customerOverview .el-table {
		font-size: 12px;
	}
	
	.customerOverview .el-table th,
	.customerOverview .el-table td,
	.customerOverview .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: center;
	}
	
	.customerOverview .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: center;
		color: #fff;
		background-color: #164B8F;
	}
	/*表头错位*/
	
	.customerOverview .el-table--border th.gutter:last-of-type {
		display: block!important;
		width: 17px!important;
	}
	
	.customerOverview .editClass {
		color: #0063FF;
		cursor: pointer;
	}
	
	.customerOverview .specliDialog .el-dialog__headerbtn .el-dialog__close {
		color: #FFF;
	}
	
	.customerOverview .specliDialog .el-dialog__header {
		padding: 0;
	}
	
	.customerOverview .specliDialog .el-dialog__body {
		padding-top: 0;
	}
	
	.customerOverview .iconBox {
		color: #000;
		height: 40px;
		line-height: 40px;
	}
	
	.customerOverview .backIcon {
		display: inline-block;
		width: 50%;
	}
	
	.customerOverview .closeIcon {
		display: inline-block;
		width: 49%;
		text-align: right;
	}
	
	.customerOverview .iconClass {
		cursor: pointer;
		font-weight: bold;
		font-size: 18px;
		color: #000;
	}
	
	.customerOverview .detailBox {
		text-indent: 20px;
		height: 70px;
		width: 70%;
		background-color: #164B8F;
		margin-bottom: 10px;
		color: #fff;
		font-size: 13px;
	}
	
	.customerOverview .modelClass {
		height: 36px;
		line-height: 36px;
		width: 100%;
	}
	
	.customerOverview .codeClass {
		display: inline-block;
		width: 48%;
	}
	
	.customerOverview .seturlClass {
		display: inline-block;
		width: 48%;
	}
	
	.customerOverview .titleBox {
		color: #000;
		margin: 0 40px;
		border-bottom: 1px solid #ccc;
		height: 50px;
		line-height: 50px;
	}
	
	.customerOverview .contentDialog {
		margin: 0 40px 40px 40px;
	}
	
	.customerOverview .contentValue {
		vertical-align: top;
		display: inline-block;
		width: 30%;
		margin-right: 2.5%;
		height: 40px;
		line-height: 26px;
		margin-top: 10px;
		color: #000;
	}
	
	.el-dialog__headerbtn .el-dialog__close {
		color: #000;
		font-size: 18px;
		font-weight: bold;
	}
	
	.customerOverview .checkAllBox2 {
		margin-bottom: 16px;
	}
	
	.customerOverview .ergencyLi {
		display: inline-block;
		padding-left: 6px;
		height: 32px;
		line-height: 32px;
		width: 22%;
		border: 1px solid #439DFD;
		background-color: #fff;
		border-radius: 3px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	/*复选框（原色）*/
	
	.customerOverview .el-checkbox {
		color: #439DFD;
	}
	
	.customerOverview .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
	}
	
	.customerOverview .el-checkbox__inner {
		border: 1px solid #439DFD!important;
		background-color: #439DFD;
		border-radius: 0!important;
	}
	
	.customerOverview .el-checkbox__input.is-checked .el-checkbox__inner,
	.customerOverview .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #439DFD;
		border-color: #439DFD!important;
	}
	
	.customerOverview .dialog-footer {
		text-align: center;
	}
	/*滚动条的样式*/
	
	.leftBox::-webkit-scrollbar {
		width: 10px;
	}
	
	.leftBox::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	
	.leftBox::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
</style>


// WEBPACK FOOTER //
// src/components/CustomerOverview/CustomerOverview.vue